import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'LBR',
  CLIENT_ID: '16',
  COUNTRY: 'lr'
}

export default config
